module.exports = __webpack_public_path__ + "static/media/director.d58dc49a.jpeg";